import { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { FormField, SelectField } from "@/components/common";
import { useTran } from "@/hooks";
import { useOrganizationStore } from "@/features/organization/hooks";
import { companyStore } from "@/features/company/stores/company.store";

const OrganizationFiltersSection = observer(() => {
  const { t } = useTran();
  const store = useOrganizationStore();

  useEffect(() => {
    void companyStore.fetchPublicCompanies();
  }, []);

  const companyOptions = useMemo(() => {
    const options = (companyStore.companyOptions || []).map((o) => ({
      ...o,
      value: String(o.value),
    }));

    return [{ value: "All", label: t("All") }, ...options];
  }, [t, companyStore.companyOptions]);

  const levelOptions = store.levelFilterOptions.map((o) =>
    o.value === "All" ? { ...o, label: t("All") } : { ...o, label: t(o.label) },
  );

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-12 items-end">
      <SelectField
        className="lg:col-span-3"
        label={t("Parent Company")}
        value={store.filters.companyId || "All"}
        onValueChange={(value) => store.setFilter("companyId", value || "All")}
        options={companyOptions}
        placeholder={t("All Companies")}
      />

      <SelectField
        className="lg:col-span-3"
        label={t("Organization Unit Level")}
        value={store.filters.level}
        onValueChange={(value) => store.setFilter("level", value)}
        options={levelOptions}
        placeholder={t("Organization Unit Level")}
      />

      <FormField
        className="lg:col-span-5"
        label={t("Search")}
        value={store.searchInput}
        onChange={(event) => store.setSearchInput(event.target.value)}
        placeholder={t("Search by name, code or country")}
      />

      <div className="lg:col-span-1">
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={store.clearFilters}
        >
          {t("Clear")}
        </Button>
      </div>
    </div>
  );
});

export default OrganizationFiltersSection;
